import { Box } from '@chakra-ui/react';

import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextSemiBold } from 'UiKit/typography';
import { useNavigate, useParams } from 'react-router-dom';

import styles from './styles.module.css';

const ActionButton = ({ values }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;

  const handleNavigate = () => {
    const date = values?.date.replaceAll('/', '-');
    const path = id ? `/report/operator-attendance/${id}/${date}` : `/report/attendance/operator/${date}`;
    navigate(path);
  };

  return (
    <Box className={styles['action-button__container']}>
      <ButtonOutline borderWidth="1.5px" onClick={handleNavigate}>
        <TextSemiBold className={styles['action-button__button--text']}>Detail</TextSemiBold>
      </ButtonOutline>
    </Box>
  );
};

export default ActionButton;
